import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import browsing from './modules/browsing'
import data from './modules/data'
import reportingVM from './modules/reporting/verticalMenu'
import todoVM from './modules/todo/verticalMenu'
import clientVM from './modules/clients/verticalMenu'
import timeSheetsVM from './modules/time-sheets/verticalMenu'
import dashboardVM from './modules/dashboard/verticalMenu'
import legalVM from './modules/legal/verticalMenu'

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
})

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        browsing,
        data,
        reportingVM,
        todoVM,
        clientVM,
        timeSheetsVM,
        dashboardVM,
        legalVM,
    },
    plugins: [vuexLocal.plugin],
})
